import { z } from 'zod';
import { ItemInstanceSchema } from '../data/items.js';
import { MAX_STASH_SIZE } from '../rules/stash.js';
/**
 * The account's chest (ADR 0079). The client says what goes in or comes
 * out and how many; the server knows where the player stands, what the
 * chest and the bag hold, and moves it under the account's lock.
 */
/** Open the chest one stands by: the server answers with `stash`. */
export const StashOpenMessageSchema = z.object({}).strict().optional();
/** A bag item, or part of its stack, into the chest. */
export const StashDepositMessageSchema = z.object({
    itemId: z.uuid(),
    quantity: z.number().int().min(1).max(99),
});
/** A chest item, or part of its stack, into the bag. */
export const StashWithdrawMessageSchema = z.object({
    itemId: z.uuid(),
    quantity: z.number().int().min(1).max(99),
});
/**
 * The chest as it now stands, to every character of the account who opened
 * it; the new inventory follows on its own to the one who moved something.
 */
export const StashStateSchema = z.object({
    /** Places it has; what lies past them (a capacity lowered) is still shown and withdrawn. */
    capacity: z.number().int().min(1).max(MAX_STASH_SIZE),
    items: z.array(z.object({
        slot: z
            .number()
            .int()
            .min(0)
            .max(MAX_STASH_SIZE - 1),
        item: ItemInstanceSchema,
    })),
});
/** To the mover alone: what went in or came out. */
export const StashResultSchema = z.object({
    direction: z.enum(['deposit', 'withdraw']),
    templateId: z.string().min(1),
    quantity: z.number().int().min(1),
});
export const STASH_REFUSALS = [
    'invalid',
    'too-far',
    'unknown-item',
    'quantity',
    /** Bound to its character (ADR 0013): another character of the account would take it. */
    'bound',
    /** A look or a companion: the wardrobe keeps them (ADR 0072). */
    'wardrobe',
    'stash-full',
    'bag-full',
    /** The bag is on a trade table (ADR 0034): it waits until the trade ends. */
    'busy',
];
export const StashRejectedSchema = z.object({ reason: z.enum(STASH_REFUSALS) });
//# sourceMappingURL=stash.js.map